import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  upload,
  uploadItemValidate,
  getFileBlob,
  getHistory,
  getExport,
  updateSort,
} from "./productAPI";

const initialState = {
  data: [],
  dataId: null,
  dataHistory: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "product/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);
export const fetchProduct = createAsyncThunk(
  "product/fetchProduct",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("product/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdNoloading = createAsyncThunk(
  "product/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const fetchHistory = createAsyncThunk(
  "product/fetchHistory",
  async (id) => {
    const response = await getHistory(id);
    return response;
  }
);

export const addItem = createAsyncThunk("product/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk(
  "product/editItem",
  async (payload) => {
    const response = await updateItem(payload);
    return response;
  }
);

export const sortItem = createAsyncThunk(
  "product/sortItem",
  async (payload) => {
    const response = await updateSort(payload);
    return response;
  }
);

export const removeById = createAsyncThunk(
  "product/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const uploadValidate = createAsyncThunk(
  "product/uploadValidate",
  async (payload) => {
    const response = await uploadItemValidate(payload);
    return response;
  }
);
export const uploadItem = createAsyncThunk(
  "product/uploadItem",
  async (payload) => {
    const response = await upload(payload);
    return response;
  }
);

export const fetchTemplate = createAsyncThunk(
  "ultis/fetchTemplate",
  async (payload) => {
    const response = await getFileBlob(payload);
    return response;
  }
);

export const fetchExport = createAsyncThunk(
  "product/fetchExport",
  async (payload) => {
    const response = await getExport(payload);
    return response;
  }
);

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchProduct.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(sortItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(sortItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadValidate.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadValidate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.dataHistory = action.payload.data.data;
      })
      .addCase(fetchExport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExport.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = productSlice.actions;

export const selectData = (state) => state.product.data;
export const selectProduct = (state) => state.product.data;
export const selectId = (state) => state.product.dataId;
export const selectIdHistory = (state) => state.product.dataHistory;
export const selectLoading = (state) => state.product.loading;
export const selectLoadingTemplate = (state) => state.product.loading;
export const selectError = (state) => state.product.error;
export const selectPageNo = (state) => state.product.pageNo;
export const selectPageSize = (state) => state.product.pageSize;
export const selectTotalRecord = (state) => state.product.totalRecord;
export const selectSelected = (state) => state.product.selected;
export const selectResult = (state) => state.product.result;

export default productSlice.reducer;
